{
  "appName": "10297",
  "entryFile": "./app-entry.jsx",
  "entryName": "10297-edu-benefits",
  "rootUrl": "/education/other-va-education-benefits/vet-tec-2/apply-for-program-form-22-10297",
  "productId": "0bc94734-cf5d-458e-b490-bb01428350f3"
}
